import React, { useState, Fragment, useContext } from "react";
import {
  Collapse,
  Container, Form,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Spinner,
} from "reactstrap";
import "./login.css";
import {observer} from 'mobx-react';
import { RootStoreContext } from "../../core/store/rootStore";
import { Redirect } from "react-router-dom";
import Role from "../../shared/enums/roleEnum";
import {toast} from "react-toastify";
import LoadingOverlay from "react-loading-overlay";

const Login = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [apiLoading, setApiLoading] = useState(false);
  const [user, setUser] = useState({
    username: "",
    password: "",
  });

  const rootStore = useContext(RootStoreContext);
  const { login, loading, isLoggedIn, getRole, sendForgotPassword } = rootStore.userStore;

  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };

  const inputChange = (e) => {
    const { name, value } = e.target;
    setUser((lastUpdate) => ({
      ...lastUpdate,
      [name]: value,
    }));
  };

  const loginHandler = (e) => {
    e.preventDefault();
    login(user);
  };

  if (isLoggedIn) {
    let role = getRole;
    if (role === Role.SUPER_ADMIN) {
      return (<Redirect to={'/companies'} />)
    } else if (role === Role.ADMIN) {
      return (<Redirect to={'/administration'} />)
    } else {
      return (<Redirect to={'/home'} />)
    }
  }

  function sendForgotPasswordEmail() {
    if (!user.username && !user.username.trim()) {
      toast.error("Entrez votre nom d'utilisateur avant de commencer le processus de récupération du mot de passe.");

      return null;
    }

    setApiLoading(true);
    sendForgotPassword({username: user.username})
      .then((result) => {
        setApiLoading(false);

        if (result)
          toast.success("Vérifiez votre e-mail et suivez les instructions pour poursuivre le processus de récupération du mot de passe.");
        else
          toast.error("une erreur s'est produite lors du traitement de votre demande. Veuillez réessayer ou contacter un administrateur.");
      });
  }

  return (
    <Fragment>
      <Navbar
        className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow"
        light
      >
        <Container>
          <NavbarBrand>
            <img
              src="/logo.png"
              alt="logo"
              style={{ width: 150 }}
            />
          </NavbarBrand>
          <NavbarToggler onClick={toggleNavbar} className="mr-2" />
          <Collapse
            className="d-sm-inline-flex flex-sm-row-reverse"
            isOpen={!collapsed}
            navbar
          >
            {/*<ul className="navbar-nav flex-grow">
              <NavItem>
                <ButtonGroup>
                  <Button color="link">FR</Button>
                  <Button color="link">DE</Button>
                </ButtonGroup>
              </NavItem>
            </ul>*/}
          </Collapse>
        </Container>
      </Navbar>
        <div className="wrap">
          <LoadingOverlay
              active={apiLoading}
              spinner>
            <form className="login-form" onSubmit={loginHandler}>
              <div className="form-header">
                <h3>EASYcreditcheck</h3>
                <p>Veuillez-vous identifier pour accéder à votre console.</p>
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-input"
                  name="username"
                  placeholder="Nom d'utilisateur"
                  value={user.username}
                  onChange={inputChange}
                />
              </div>
              <div className="form-group">
                <input
                  name="password"
                  type="password"
                  className="form-input"
                  placeholder="Mot de passe"
                  value={user.password}
                  onChange={inputChange}
                />
              </div>
              <div className="form-group">
                <button
                  className="form-button"
                  type="submit"
                >
                  {!loading ? (
                    "Connexion"
                  ) : (
                    <Spinner animation="border" role="status"></Spinner>
                  )}
                </button>
              </div>
              <div className="form-group text-center">
                <button type="button" className="btn btn-link" onClick={sendForgotPasswordEmail}>Vous avez oublié votre mot de passe ?</button>
              </div>
              <div className="form-footer"></div>
            </form>
          </LoadingOverlay>
        </div>
    </Fragment>
  );
};

export default observer(Login);
